import { z } from "zod";
import { nonNegativeMoneySchema, uuidSchema } from "../common/primitives.js";
/**
 * POS ayarları (Prompt 15). Satır ŞİRKET düzeyindedir; `stationId` doluysa o istasyon için geçersiz kılmadır
 * (`shift_settings` kalıbı). Hiçbir eşik koda gömülmez (AGENTS.md §3.12) ve tümü "doğrulanmalı" gelir.
 */
const settingsFields = {
    fiscalRequired: z
        .boolean()
        .describe("ÖKC zorunlu mu: true → cihaz yoksa / arızalıysa kasa satış YAPMAZ (503 POS_FISCAL_UNAVAILABLE)"),
    offlineCreditTolerance: nonNegativeMoneySchema.describe("Çevrimdışı veresiye toleransı (kuruş): önbellekteki limitin bu kadar üstüne izin verilir"),
    pendingFuelAutoSettleMinutes: z
        .number()
        .int()
        .min(0)
        .max(1440)
        .describe("Bekleyen dolum bu süre sonunda 'pompada nakit ödendi' sayılır; 0 = kapalı"),
    ageRestrictedConfirmation: z.boolean().describe("Yaş sınırlı üründe personel onayı istensin mi"),
    receiptFooter: z.string().trim().max(300).nullable().describe("Fiş altına basılan serbest metin"),
};
export const posSettingsSchema = z.object({
    companyId: uuidSchema,
    stationId: uuidSchema.nullable().describe("Dolu ise bu istasyona özel geçersiz kılma"),
    /** true → kayıt YOKTUR; dönen değerler ürün varsayılanıdır (ilk PUT satırı oluşturur). */
    isDefault: z.boolean(),
    ...settingsFields,
    needsVerification: z.boolean().describe("Değerler işletme tarafından doğrulanmalı"),
    version: z.number().int().min(0).describe("İyimser kilit sürümü; 0 = henüz kaydedilmemiş"),
});
/** PUT ile TAMAMI değiştirilir (kısmi güncelleme yok) — adı `save…` (bkz. `common/patch.test.ts`). */
export const savePosSettingsSchema = z.object({
    companyId: uuidSchema,
    stationId: uuidSchema.nullable().optional().describe("Verilirse istasyon geçersiz kılması yazılır"),
    ...settingsFields,
    needsVerification: z.boolean().optional(),
    version: z.number().int().min(0).describe("Okunan sürüm; 0 = kayıt yoktu"),
});
export const posSettingsQuerySchema = z.object({
    companyId: uuidSchema,
    stationId: uuidSchema.optional().describe("Verilirse istasyonun ETKİN ayarı (yoksa şirket satırı) döner"),
});
//# sourceMappingURL=settings.js.map